import { css } from "@emotion/css";
import { LockIcon, SVGProps } from "components/icons";
import React from "react";
import { E_Route } from "utils/constants";
import * as Tooltip from "@radix-ui/react-tooltip";
import { theme } from "assets/theme";
import { Link } from "react-router-dom";
import { Text } from "components/common";

type Props = {
  Icon: React.FC<SVGProps>;
  active: boolean;
  label: string;
  route: E_Route;
  mobile?: boolean;
  disabled?: boolean;
  featureFlag?: boolean;
};
export const NavItem: React.FC<Props> = ({
  Icon,
  active,
  route,
  label,
  disabled,
  featureFlag,
  mobile,
}) => {
  return featureFlag ? null : (
    <Tooltip.Provider>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <div className="IconButton">
            <Link
              to={route}
              style={{
                textDecoration: "none",
                all: disabled ? "unset" : "initial",
                // disble click event
                pointerEvents: disabled ? "none" : "auto",
                cursor: disabled ? "not-allowed" : "pointer",
              }}
            >
              <div
                className={css`
                  width: ${mobile ? "100%" : "41px"};
                  height: 41px;
                  background: ${active
                    ? "rgb(170, 239, 101, 0.1)"
                    : "transparent"};
                  border-radius: 8px;
                  display: flex;
                  flex-direction: row;
                  justify-content: ${mobile ? "flex-start" : "center"};
                  align-items: center;
                  cursor: pointer;
                  text-decoration: none;
                  transition: background 0.3s;
                  margin: auto;
                  margin-bottom: 16px;
                  position: relative;
                `}
              >
                <Icon
                  style={{
                    width: "24px",
                    height: "24px",
                    marginRight: mobile ? "8px" : undefined,
                  }}
                  fill={
                    disabled
                      ? "disabled"
                      : active
                        ? "highlight/3"
                        : mobile
                          ? "primary"
                          : "tertiary"
                  }
                />
                {mobile && <Text.Body2XS>{label}</Text.Body2XS>}
                {disabled && (
                  <div
                    className={css`
                      position: absolute;
                      bottom: 0px;
                      right: 2px;
                    `}
                  >
                    <LockIcon
                      fill="highlight/1"
                      style={{ width: "12px", height: "12px" }}
                    />
                  </div>
                )}
              </div>
            </Link>
          </div>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            side="right"
            className={css`
              font-size: 14px;
              color: ${theme.colors.text.seconday};
            `}
            sideOffset={5}
          >
            {label} {disabled ? "(Not available in Free plan)" : ""}
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};
